import React from "react";
import { Box, Button, Heading, HStack, Table, Thead, Tbody, Tr, Th, Td, VStack, useToast, IconButton, Image } from "@chakra-ui/react";
import { listTechnicians, removeTechnician, clearTechnicians } from "../../../utils/formsApi";
import { FiTrash2, FiEdit2 } from "react-icons/fi";
import TechniciansAddModal from "../../../components/technicians/TechniciansAddModal";

export default function Technicians() {
  const toast = useToast();
  const [items, setItems] = React.useState([]);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editingTech, setEditingTech] = React.useState(null);

  const reload = React.useCallback(async () => {
    const rows = await listTechnicians();
    setItems(rows);
  }, []);
  React.useEffect(() => { reload(); }, [reload]);

  const handleAdded = async () => { await reload(); };

  const handleDelete = async (id) => {
    await removeTechnician(id);
    reload();
    toast({ title: "Silindi", status: "info" });
  };

  return (
    <VStack align="stretch" spacing={4}>
      <Box>
        <Heading size="md" mb={2}>Teknisyenler</Heading>
        <HStack spacing={3}>
          <Button onClick={() => { setEditingTech(null); setModalOpen(true); }} colorScheme="blue">Yeni Teknisyen</Button>
          <Button variant="outline" colorScheme="red" onClick={async () => {
            if (!window.confirm("Tüm teknisyen kayıtları silinecek. Emin misiniz?")) return;
            await clearTechnicians();
            await reload();
          }}>Tümünü Sil</Button>
        </HStack>
        <TechniciansAddModal
          isOpen={modalOpen}
          onClose={() => { setModalOpen(false); setEditingTech(null); }}
          onAdded={handleAdded}
          technician={editingTech}
        />
      </Box>
      <Box border="1px solid" borderColor="gray.200" borderRadius="lg" overflow="hidden" bg="white">
        <Table size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>Foto</Th>
              <Th>Ad/Soyad</Th>
              <Th>Yetki/Ünvan</Th>
              <Th>Yetenek/Görev</Th>
              <Th>Takım/Grup</Th>
              <Th>E-posta</Th>
              <Th>Telefon</Th>
              <Th width="100px"></Th>
            </Tr>
          </Thead>
          <Tbody>
            {items.map((t) => (
              <Tr key={t.id}>
                <Td>{t.photo_url ? <Image src={t.photo_url} alt={t.name} boxSize="40px" objectFit="cover" borderRadius="md" /> : "-"}</Td>
                <Td>{[t.first_name, t.last_name].filter(Boolean).join(" ") || t.name}</Td>
                <Td>{t.title || "-"}</Td>
                <Td>{t.skill || "-"}</Td>
                <Td>{t.team_group || "-"}</Td>
                <Td>{t.email || "-"}</Td>
                <Td>{t.phone || "-"}</Td>
                <Td textAlign="right">
                  <HStack justify="flex-end">
                    <IconButton aria-label="Düzenle" icon={<FiEdit2 />} size="sm" onClick={() => { setEditingTech(t); setModalOpen(true); }} />
                    <IconButton aria-label="Sil" icon={<FiTrash2 />} size="sm" onClick={() => handleDelete(t.id)} />
                  </HStack>
                </Td>
              </Tr>
            ))}
            {items.length === 0 && (
              <Tr>
                <Td colSpan={8}>Kayıt yok</Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>
    </VStack>
  );
}
